import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import style from "./FAQMagicBg.module.scss";
import ArrowIcon from "../../../public/remove_back/magic_bg/arrow.svg";
import getFaqLocales from "../../../locales/locales_faq";

function FAQMagicBg({ dictionary }) {
	const router = useRouter();

	const dictionaryFaq = getFaqLocales(router.locale);

	const questionsData = [
		{
			id: 1,
			question: "How to get the best result?",
			answer: dictionary["faq"]["Enter a description of what you want to see"],
		},
		{
			id: 2,
			question: "In what language can I enter a query?",
			answer: dictionary["use languages"],
		},
		{
			id: 3,
			question: " How does AI generate images?",
			answer: dictionary["faq"]["ai model is trained on a huge array of image-text"],
		},
		{
			id: 4,
			question: "Is it free?",
			answer: dictionary["page_erase"]["faq"]["answer_free"],
		},
		{
			id: 5,
			question: "What styles may I use?",
			answer: dictionary["faq"]["you can use from our templates"],
		},
		{
			id: 6,
			question: "What tariffs users can use this service?",
			answer: dictionary["faq"]["The service is available for users of all tariffs"],
		},
		{
			id: 7,
			question: "Can I save the image I have created?",
			answer: dictionary["page_generator"]["faq"]["answer_save"],
		},
		{
			id: 8,
			question: "Why do I have to wait for an image to be created?",
			answer: dictionary["faq"]["When you submit your query"],
		},
		{
			id: 9,
			question: "Where can the created images and artworks be used?",
			answer: dictionary["faq"]["You can find good examples of using AI"],
		},
		{
			id: 10,
			question: dictionary["page_image_generator"]["faq"]["question_10"],
			answer: dictionary["page_image_generator"]["faq"]["answer_10"],
			active: false,
			anchor: "negative",
			images: [
				{
					id: 1,
					text: "prompt_mystery_forest",
					src: "/faq/ml_faq/negative1.jpg",
				},
				{
					id: 2,
					text: "prompt_negative_prompt",
					src: "/faq/ml_faq/negative2.jpg",
				},
				{
					id: 3,
					text: "prompt_boy_on_the_moon",
					src: "/faq/ml_faq/negative3.jpg",
				},
				{
					id: 4,
					text: "prompt_negative_prompt_boy",
					src: "/faq/ml_faq/negative4.png",
				},
			],
		},
		{
			id: 11,
			question: dictionary["page_image_generator"]["faq"]["question_11"],
			answer: dictionary["page_image_generator"]["faq"]["answer_11"],
			active: false,
			anchor: "seed",
			images: [
				{
					id: 1,
					text: "boy_red",
					src: "/faq/ml_faq/seed1.jpg",
				},
				{
					id: 2,
					text: "boy_blue",
					src: "/faq/ml_faq/seed2.jpg",
				},
				{
					id: 3,
					text: "boy_yellow",
					src: "/faq/ml_faq/seed3.jpg",
				},
				{
					id: 4,
					text: "boy_beige",
					src: "/faq/ml_faq/seed4.jpg",
				},
			],
		},
		{
			id: 12,
			question: dictionary["page_image_generator"]["faq"]["question_12"],
			answer: dictionary["page_image_generator"]["faq"]["answer_12"],
			active: false,
			anchor: "steps",
			images: [
				{
					id: 1,
					text: "prompt_wolf",
					src: "/faq/ml_faq/steps1.jpg",
				},
				{
					id: 2,
					text: "prompt_wolf",
					src: "/faq/ml_faq/steps2.jpg",
				},
				{
					id: 3,
					text: "prompt_wolf",
					src: "/faq/ml_faq/steps3.jpg",
				},
			],
		},
		{
			id: 13,
			question: dictionary["page_image_generator"]["faq"]["question_13"],
			answer: dictionary["page_image_generator"]["faq"]["answer_13"],
			active: false,
			anchor: "sampler",
			images: [
				{
					id: 1,
					text: "k_dpmpp_2m",
					src: "/faq/ml_faq/sampler1.jpg",
				},
				{
					id: 2,
					text: "k_dpmpp_2s_a",
					src: "/faq/ml_faq/sampler2.jpg",
				},
				{
					id: 3,
					text: "plms",
					src: "/faq/ml_faq/sampler3.jpg",
				},
				{
					id: 4,
					text: "ddim",
					src: "/faq/ml_faq/sampler4.jpg",
				},
				{
					id: 5,
					text: "k_dpm_fast",
					src: "/faq/ml_faq/sampler5.jpg",
				},
				{
					id: 6,
					text: "k_dpm_adaptive",
					src: "/faq/ml_faq/sampler6.jpg",
				},
				{
					id: 7,
					text: "k_lms",
					src: "/faq/ml_faq/sampler7.jpg",
				},
				{
					id: 8,
					text: "k_dpm_2",
					src: "/faq/ml_faq/sampler8.jpg",
				},
				{
					id: 9,
					text: "k_dpm_2_a",
					src: "/faq/ml_faq/sampler9.jpg",
				},
				{
					id: 10,
					text: "k_euler",
					src: "/faq/ml_faq/sampler10.jpg",
				},
				{
					id: 11,
					text: "k_euler_a",
					src: "/faq/ml_faq/sampler11.jpg",
				},
				{
					id: 12,
					text: "k_heun",
					src: "/faq/ml_faq/sampler12.jpg",
				},
			],
		},
	];
	const anchor = router.asPath.split("#")[1];
	const checkAnchorQuestion = () => {
		if (anchor) {
			const questionWithAnchor = questionsData.find((item) => item.anchor === anchor);
			toggleQuestion(questionWithAnchor.id);
		}
	};
	const [openQuestions, setOpenQuestion] = useState([]);
	const checkActiveQuestion = (id) => {
		return openQuestions.includes(id);
	};
	const toggleQuestion = (id) => {
		checkActiveQuestion(id)
			? setOpenQuestion((prev) => {
					return prev.filter((item) => {
						return item !== id;
					});
			  })
			: setOpenQuestion((prev) => {
					return [...prev, id];
			  });
	};
	useEffect(
		() => {
			checkAnchorQuestion();
			if (anchor) {
				router.replace(router.locale + "/text-to-image-generator/");
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[router]
	);

	return (
		<section className={style.block}>
			<h2 className={style.title}>{dictionaryFaq["page title"]}</h2>
			<div className={style.container}>
				{questionsData
					.filter((e) => !!e.answer)
					.map((item) => (
						<div onClick={() => toggleQuestion(item.id)} key={item.id} className={style.item}>
							{item.anchor && <span id={item.anchor} className="anchor"></span>}
							<div className={`${style.question} ${checkActiveQuestion(item.id) ? style.active : ""}`}>
								<h3>{dictionary["fag"][item.question] || dictionary["faq"][item.question] || dictionary[item.question] || item.question}</h3>
								<ArrowIcon className={style.arrow} />
							</div>
							<div className={style.answer}>
								<div>{item.answer}</div>
								{item.images?.length > 0 && (
									<div className={style.imageWrapper}>
										{item.images.map((imageItem) => {
											return (
												<div key={imageItem.id} className={style.imageItem}>
													<Image width={100} height={100} className={style.image} src={imageItem.src} alt={imageItem.text} />
													<p className={style.imageText} dangerouslySetInnerHTML={{ __html: `${dictionary[imageItem.text] || imageItem.text}` }}></p>
												</div>
											);
										})}
									</div>
								)}
							</div>
						</div>
					))}
			</div>
		</section>
	);
}

export default FAQMagicBg;
